module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cschedule-page"
  }, [_c('div', {
    staticClass: "flex-container section-top"
  }, [_c('div', {
    staticClass: "current-balance w-full"
  }, [_c('p', {
    staticClass: "payment-item-text text-center",
    on: {
      "click": function($event) {
        _vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' ? _vm.editBalance = !_vm.editBalance : {}
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_budget')) + ": [ "), _c('b', {
    style: (_vm.currentEur > 0 ? 'color: green;' : 'color: red;')
  }, [_vm._v(_vm._s(_vm.currentEur) + " €")]), _vm._v(" ] [ "), _c('b', {
    style: (_vm.currentRsd > 0 ? 'color: green;' : 'color: red;')
  }, [_vm._v(_vm._s(_vm.currentRsd) + " RSD")]), _vm._v(" ]\n        "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('span', {
    staticClass: "new-button"
  }, [_c('i', {
    staticClass: "ti-pencil"
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.editBalance) ? _c('div', {
    staticClass: "foo section-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("€")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEur),
      expression: "newEur"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "priceByUser"
    },
    domProps: {
      "value": (_vm.newEur)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEur = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("RSD")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRsd),
      expression: "newRsd"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "priceByUser"
    },
    domProps: {
      "value": (_vm.newRsd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRsd = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.updateBudget()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "foo cschedule-shell"
  }, [_c('H1', {
    staticClass: "cschedule-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_schedule")))]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _vm.locale.t("label_from") : _vm.locale.t("label_date")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "section-top-xs"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center cschedule-search-row"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.getSchedules(true)
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_search')) + "\n          ")])])])]), _vm._v(" "), (_vm.schedules.length === 0 || (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') || (_vm.role === 'ROLE_TRAINER' && _vm.canTrainerOpenSchedule())) ? _c('div', [_c('h3', {
    staticClass: "cschedule-subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_start')))]), _vm._v(" "), _c('div', {
    staticClass: "account--wrapper cschedule-open-shell"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4 cschedule-open-col"
  }, [_c('div', {
    staticClass: "card ui-card form--account cschedule-open-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                          " + _vm._s(_vm.locale.t('label_schedule_insert_money')) + " €\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newScheduleEur),
      expression: "newScheduleEur",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input width-seven-tenths",
    attrs: {
      "type": "number",
      "name": "priceByUser",
      "step": "any"
    },
    domProps: {
      "value": (_vm.newScheduleEur)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newScheduleEur = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        _vm.newScheduleEur = _vm.newScheduleEur === 0 ? -1 : _vm.newScheduleEur * -1;
      }
    }
  }, [_vm._v("\n                            −\n                          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                          " + _vm._s(_vm.locale.t('label_schedule_insert_money')) + " RSD\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.newScheduleRsd),
      expression: "newScheduleRsd",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input width-seven-tenths",
    attrs: {
      "type": "number",
      "name": "priceByUser",
      "step": "any"
    },
    domProps: {
      "value": (_vm.newScheduleRsd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newScheduleRsd = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        _vm.newScheduleRsd = _vm.newScheduleRsd === 0 ? -1 : _vm.newScheduleRsd * -1;
      }
    }
  }, [_vm._v("\n                            −\n                          ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openSchedule()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                        ")])])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu cschedule-scrollmenu"
  }, _vm._l((_vm.filterSchedules), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSelectFilter(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassFilter(item)
    }, [_vm._v(_vm._s(_vm.isSelectedFilter(item) ? '✔ ' : '') + _vm._s(item.label))])])]), _vm._v(" \n          ")])
  }), 0), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "scrollmenuStart cschedule-scrollmenu-start"
  }, _vm._l((_vm.schedulesNames), function(s) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSelectFilterShift(s)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassFilterShift(s)
    }, [_vm._v("\n                           " + _vm._s(_vm.isSelectedFilterShift(s) ? '✔ ' : '') + _vm._s(s) + "\n                         ")])])]), _vm._v(" \n            ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
    staticClass: "foo cschedule-mobile-shell"
  }, [(!_vm.isLoading && _vm.schedules.length > 0) ? _c('div', [_c('div', {
    staticClass: "wod-container"
  }, _vm._l((_vm.filteredSchedules), function(item) {
    return _c('div', [_c('div', {
      staticClass: "term-item section-top-xs"
    }, [_c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_c('b', [_vm._v(_vm._s(item.schedule.firstName) + " " + _vm._s(item.schedule.lastName))])]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_date')) + ": "), _c('b', [_vm._v(_vm._s(_vm.displayDate(item.schedule.startTimestamp)))])]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_inserted_money')) + ": "), _c('b', [_vm._v("€ " + _vm._s(item.schedule.moneyEurIn))]), _vm._v(" / "), _c('b', [_vm._v("RSD " + _vm._s(item.schedule.moneyRsdIn))])]), _c('br'), _vm._v(" "), (item.schedule.state === 'ACTIVE') ? _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_inserted_money_current')) + ": "), _c('b', [_vm._v("€ " + _vm._s(item.schedule.moneyEurIn + item.schedule.currentEur))]), _vm._v(" / "), _c('b', [_vm._v("RSD " + _vm._s(item.schedule.moneyRsdIn + item.schedule.currentRsd))])]) : _vm._e(), (item.schedule.state === 'ACTIVE') ? _c('br') : _vm._e(), _vm._v(" "), (item.schedule.state !== 'ACTIVE') ? _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_additional_costs')) + ": "), _c('b', [_vm._v("€ " + _vm._s(item.schedule.additionalCostEur))]), _vm._v(" / "), _c('b', [_vm._v("RSD " + _vm._s(item.schedule.additionalCostRsd))])]) : _vm._e(), (item.schedule.state !== 'ACTIVE') ? _c('br') : _vm._e(), _vm._v(" "), (item.schedule.state !== 'ACTIVE') ? _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_out_money')) + ": "), _c('b', [_vm._v("€ " + _vm._s(item.schedule.moneyEurOut - (item.schedule.additionalCostEur != null ? item.schedule.additionalCostEur : 0)))]), _vm._v("/ "), _c('b', [_vm._v("RSD " + _vm._s(item.schedule.moneyRsdOut - (item.schedule.additionalCostRsd != null ? item.schedule.additionalCostRsd : 0)))])]) : _vm._e(), (item.schedule.state !== 'ACTIVE') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showProfit()) ? _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_profit')) + ": "), _c('b', [_vm._v("€ " + _vm._s(item.schedule.profitEur.toFixed(2)))])]) : _vm._e(), (_vm.showProfit()) ? _c('br') : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "term-subitem-medium note-text"
    }, [_vm._v(_vm._s(_vm.locale.t('label_status')) + " "), _c('b', [_vm._v(_vm._s(_vm.translateState(item.schedule.state)))]), _vm._v(_vm._s(item.schedule.lockedUsername != null ? '(' + item.schedule.lockedUsername + ')' : ''))]), _vm._v(" "), _c('br'), _vm._v(" "), (item.schedule.state !== 'LOCKED') ? _c('div', {
      staticClass: "flex-container section-top-sm"
    }, [(item.schedule.state === 'ACTIVE') ? _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.additionalCost(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-money"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_additional_cost')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.schedule.state === 'ACTIVE') ? _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.editSchedule(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.schedule.state === 'ACTIVE') ? _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.closeSchedule(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_close_schedule')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.schedule.state !== 'LOCKED' && _vm.role.includes('ADMIN')) ? _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.approveSchedule(item.schedule, item.items)
        }
      }
    }, [_c('i', {
      staticClass: "ti-hand-open"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_approve_schedule')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.schedule.state === 'ACTIVE' && _vm.role.includes('ADMIN')) ? _c('div', {
      staticClass: "new-button term-subitem-small",
      on: {
        "click": function($event) {
          return _vm.deleteSchedule(item.schedule)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
      staticClass: "foo section-top-sm cschedule-show-more-wrap"
    }, [_c('show-more', {
      on: {
        "update:selectedModel": function($event) {
          return _vm.onUpdate($event, item)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.showItems) ? _c('div', [_c('div', {
      staticClass: "scrollmenuStart cschedule-scrollmenu-start"
    }, _vm._l((_vm.filterScheduleItems), function(itemFilter) {
      return _c('span', [_c('span', {
        staticClass: "chips-group clickable",
        attrs: {
          "value": ""
        },
        on: {
          "click": function($event) {
            return _vm.onSelectFilterItem(itemFilter, item)
          }
        }
      }, [_c('span', {
        staticClass: "single-chip"
      }, [_c('span', {
        class: _vm.getChipClassFilterItem(itemFilter, item)
      }, [_vm._v("\n                                   " + _vm._s(_vm.isSelectedFilterItem(itemFilter, item) ? '✔ ' : '') + _vm._s(itemFilter.label) + "\n\n                                 ")])])]), _vm._v(" \n                    ")])
    }), 0), _vm._v(" "), _vm._l((item.filteredItems), function(subItem) {
      return _c('div', {
        staticClass: "term-item"
      }, [_c('div', {
        staticClass: "schedule-item-row"
      }, [(subItem.articleId == null) ? _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_c('b', {
        staticStyle: {
          "color": "#FF0000"
        }
      }, [_vm._v(_vm._s(subItem.comment))])]) : _vm._e(), _vm._v(" "), (subItem.articleId != null) ? _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.getItemDetails(subItem.articleId)
          }
        }
      }, [_vm._v(_vm._s(_vm.locale.t('label_serial_num')) + ":"), _c('b', [_vm._v(_vm._s(String(subItem.articleId).padStart(6, '0')) + " " + _vm._s(subItem.articleMainCategory != null ? subItem.articleMainCategory : '') + " " + _vm._s(subItem.articleSubCategory != null ? subItem.articleSubCategory : ''))])])]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', {
        staticClass: "schedule-meta"
      }, [_c('i', [_vm._v("-" + _vm._s(subItem.itemLabel) + "-")])])]), _vm._v(" "), (subItem.articleForChange != null && subItem.articleForChange.length > 0) ? _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_vm._v(_vm._s(_vm.locale.t('label_change_for')) + ": "), _c('b', [_vm._v(_vm._s(subItem.articleForChange))])]) : _vm._e(), (subItem.articleForChange != null && subItem.articleForChange.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_vm._v(_vm._s(_vm.locale.t('label_date')) + ": "), _c('b', [_vm._v(_vm._s(_vm.displayDate(subItem.timestamp)))])]), _c('br'), _vm._v(" "), _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_item_cost')) + ": "), _c('b', [_vm._v("€ " + _vm._s(subItem.moneyEur))]), _vm._v(" / "), _c('b', [_vm._v("RSD " + _vm._s(subItem.moneyRsd))])]), _c('br'), _vm._v(" "), _c('p', {
        staticClass: "term-subitem-medium note-text"
      }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_profit')) + ": "), _c('b', [_vm._v("€ " + _vm._s(subItem.profitEur))]), _vm._v(" / "), _c('b', [_vm._v("RSD " + _vm._s(subItem.profitRsd))])]), _c('br'), _vm._v(" "), (item.schedule.state !== 'LOCKED') ? _c('div', {
        staticClass: "flex-container section-top-sm"
      }, [(item.schedule.state === 'ACTIVE') ? _c('div', {
        staticClass: "new-button term-subitem-small",
        on: {
          "click": function($event) {
            return _vm.editScheduleItem(subItem)
          }
        }
      }, [_c('i', {
        staticClass: "ti-pencil"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                    ")]) : _vm._e()]) : _vm._e()])
    })], 2) : _vm._e()]), _vm._v(" "), _c('hr')])
  }), 0), _vm._v(" "), _c('p')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isMobile() && !_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_inserted_money')) + " €/RSD")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_inserted_money_current')) + " €/RSD\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_schedule_out_money')) + " €/RSD")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_status')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_close_schedule_title")))]), _vm._v(" "), (_vm.role.includes('ADMIN')) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t("label_approve_schedule_title")) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.role.includes('ADMIN')) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete")))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSchedules), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.schedule.firstName) + " " + _vm._s(item.schedule.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayDate(item.schedule.startTimestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.schedule.moneyEurIn) + " € / " + _vm._s(item.schedule.moneyRsdIn) + " RSD")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("€ " + _vm._s(item.schedule.moneyEurIn + item.schedule.currentEur))]), _vm._v(" / "), _c('b', [_vm._v("RSD\n                " + _vm._s(item.schedule.moneyRsdIn + item.schedule.currentRsd))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.schedule.moneyEurOut) + " € / " + _vm._s(item.schedule.moneyRsdOut) + " RSD")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.translateState(item.schedule.state)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_close_schedule')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.closeSchedule(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_close_schedule')) + "\n                ")])]), _vm._v(" "), (_vm.role.includes('ADMIN')) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_approve_schedule')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.approveSchedule(item.schedule, item.items)
        }
      }
    }, [_c('i', {
      staticClass: "ti-hand-open"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_approve_schedule')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.role.includes('ADMIN')) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [(item.schedule.state === 'ACTIVE') ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteSchedule(item.schedule)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                ")]) : _vm._e()]) : _vm._e()])
  }), 0)])])])]) : _vm._e()], 1), _vm._v(" "), _c('close-schedule', {
    attrs: {
      "scheduleObject": _vm.scheduleToClose,
      "show": _vm.scheduleToClose != null
    }
  }), _vm._v(" "), _c('change-schedule-item', {
    attrs: {
      "item": _vm.scheduleItemToEdit,
      "show": _vm.scheduleItemToEdit != null
    }
  }), _vm._v(" "), _c('edit-schedule', {
    attrs: {
      "scheduleObject": _vm.scheduleToEdit,
      "show": _vm.scheduleToEdit != null
    }
  }), _vm._v(" "), _c('additional-cost-schedule', {
    attrs: {
      "scheduleObject": _vm.additionalCostItem,
      "show": _vm.additionalCostItem != null
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e168910c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CSchedule/CSchedule.vue
// module id = 856
// module chunks = 0